const getVehicleStatus = (status: number, t: any) => {
  let statusName = "";
  switch (status) {
    case 0:
      statusName = t("initialization");
      break;
    case 1:
      statusName = t("idle");
      break;
    case 2:
    case 3:
    case 4:
      statusName = t("offline");
      break;
    case 5:
      statusName = t("dormancy");
      break;
    case 6:
      statusName = t("crashstop");
      break;
    case 7:
      statusName = t("fault");
      break;
    case 8:
    case 9:
      statusName = t("mmode");
      break;
    case 10:
      statusName = t("duringcleaning");
      break;
    case 11:
      statusName = t("headingtodepot");
      break;
    case 12:
      statusName = t("headingtodockingstations");
      break;
    case 13:
    case 14:
      statusName = t("autosupplying");
      break;
  }
  return statusName;
};

const getCarStatusType = (vehicle_status: string, t: any) => {
  const status = Number(vehicle_status);
  let str = "";
  if (vehicle_status != null) {
    switch (status) {
      case 0:
        str = t("initialization");
        break;
      case 1:
        str = t("dormancy");
        break;
      case 2:
        str = t("remotecontrolready");
        break;
      case 3:
        str = t("idle");
        break;
      case 4:
        str = t("remotecontroldriving");
        break;
      case 5:
        str = t("autonomousdriving");
        break;
      case 6:
        str = t("manualintervention");
        break;
      case 7:
        str = t("crashstop");
        break;
      case 8:
        str = t("fault");
        break;
      case 9:
        str = t("supplying");
        break;
      case 10:
        str = t("shutdown");
        break;
      case 11:
        str = t("forcedlabor");
        break;
      case 20:
        str = t("duringcleaning");
        break;
      case 21:
        str = t("gotosupply");
        break;
      case 22:
        str = t("gotodock");
        break;
      case 23:
        str = t("supplying");
        break;
    }
  }
  return str;
};
const getCleanMode = (type: number, t: any) => {
  const status = Number(type);
  let str = "";
  switch (status) {
    case -1:
      str = t("customize");
      break;
    case 1:
      str = t("deepcleaning");
      break;
    case 2:
      str = t("dailycleaning");
      break;
    case 3:
      str = t("silentcleaning");
      break;
    case 4:
      str = t("customize");
      break;
    case 5:
      str = t("rewashingmode");
      break;
    case 6:
      str = t("energysavingmode");
      break;
    case 7:
      str = t("dustpushmode");
      break;
    case 8:
      str = t("customize");
      break;
    case 9:
      str = t("rewashingmode");
      break;
    case 10:
      str = t("energysavingmode");
      break;
    case 11:
      str = t("dustpushmode");
      break;
    case 12:
      str = t("customize");
      break;
  }
  return str;
};
const vehicleStatus = (type: number, t: any) => {
  let modetype = "";
  switch (type) {
    case 0:
      modetype = t("initialization");
      break;
    case 1:
      modetype = t("dormancy");
      break;
    case 2:
      modetype = t("remotecontrolready");
      break;
    case 3:
      modetype = t("idle");
      break;
    case 4:
      modetype = t("remotecontroldriving");
      break;
    case 5:
      modetype = t("autonomousdriving");
      break;
    case 6:
      modetype = t("manualdrive");
      break;
    case 7:
      modetype = t("crashstop");
      break;
    case 8:
      modetype = t("fault");
      break;
    case 9:
      modetype = t("automaticsupply");
      break;
    case 10:
      modetype = t("shutdown");
      break;
    case 11:
      modetype = t("forcedlabor");
      break;
  }

  return modetype;
};
export { getVehicleStatus, getCarStatusType, getCleanMode, vehicleStatus };
